/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * プロジェクト共通モデル
 * @export
 * @interface ProjectCommonModel
 */
export interface ProjectCommonModel {
    /**
     * プロジェクト名
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'project_name'?: string;
    /**
     * プロジェクト種別名
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'project_type_name'?: string;
    /**
     * オーナー企業名
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'owner_company_name'?: string;
    /**
     * 本支店オブジェクト名
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'branch_object_name'?: string;
    /**
     * プロジェクトステータスコード - PS10:稼働中 - PS30:凍結 - PS50:完了 - PS90:削除 
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'project_status_code'?: ProjectCommonModelProjectStatusCodeEnum;
    /**
     * プロジェクトステータス
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'project_status'?: string;
    /**
     * 期間（開始）
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'started_on'?: string | null;
    /**
     * 期間（終了）
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'ended_on'?: string | null;
    /**
     * 責任者名 <br> 画面表示用にロケールに対応する形式に以下を変換した値 <br> 責任者姓、責任者ミドルネーム、責任者名 
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'responsible_person_name'?: string;
    /**
     * 責任者名(ミドルネームなし) <br> 画面表示用にロケールに対応する形式に以下を変換した値 <br> 責任者姓、責任者名 
     * @type {string}
     * @memberof ProjectCommonModel
     */
    'responsible_person_name_without_middle_name'?: string;
}

export const ProjectCommonModelProjectStatusCodeEnum = {
    Ps10: 'PS10',
    Ps30: 'PS30',
    Ps50: 'PS50',
    Ps90: 'PS90'
} as const;

export type ProjectCommonModelProjectStatusCodeEnum = typeof ProjectCommonModelProjectStatusCodeEnum[keyof typeof ProjectCommonModelProjectStatusCodeEnum];


